import { HttpParams } from '@angular/common/http';

export class RecorrenciaFilter {

  empresaId: string;
  licencaId: string;
  licencasId: string[] = new Array();
  pedidoNumero: string;
  cpf: string;


  constructor(empresaId: string) {
    this.empresaId = empresaId;
  }

  getSearchParams() {
    let params = new HttpParams();

    if (this.empresaId !== undefined && this.empresaId !== null) {
      params = params.set('empresaId', this.empresaId);
    }

    if (this.licencaId !== undefined && this.licencaId !== null && this.licencaId.trim().length > 3) {
      params = params.set('licencaId', this.licencaId);
    }

    if (this.licencasId !== undefined && this.licencasId !== null && this.licencasId.length > 0) {
      params = params.set('licencasId', this.licencasId.toString());
    }

    if (this.pedidoNumero !== undefined && this.pedidoNumero !== null && this.pedidoNumero.trim().length > 0) {
      params = params.set('pedidoNumero', this.pedidoNumero);
    }

    if (this.cpf !== undefined && this.cpf !== null && this.cpf.trim().length > 0) {
      params = params.set('cpf', this.cpf);
    }

    return params;
  }

}
